import { shadowStandard, SizableText, YStack, YStackProps } from '@my/ui'

interface BrandGroupItemTitleProps {
  title: string
  id?: string
}

export const BrandGroupItemTitle = ({
  title,
  id,
  ...props
}: BrandGroupItemTitleProps & YStackProps) => (
  <YStack
    id={id}
    p="$2"
    backgroundColor="$white"
    w={42}
    h={42}
    display="flex"
    alignItems="center"
    justifyContent="center"
    br="$2"
    my="$3"
    maxWidth={42}
    overflow="hidden"
    {...shadowStandard}
    {...props}
  >
    <SizableText fontSize={18} color="$overlay10">
      {title}
    </SizableText>
  </YStack>
)
